var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArquendaIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "Arquenda",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "cut",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 44,0 8,40 0,40",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#cut)",
    fill: "#FFFFFF",
    d: "M24 4h52c11 0 20 9 20 20v52c0 11-9 20-20 20H24c-11 0-20-9-20-20V24C4 13 13 4 24 4Zm2 13c-5 0-9 4-9 9v48c0 5 4 9 9 9h48c5 0 9-4 9-9V26c0-5-4-9-9-9H26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4,4 26,4 13,18 4,28",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55,17 83,17 83,52 68,52",
    fill: "#7466F1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArquendaIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arquenda-icon-white.f1aa2c1bae1e0465aee2f0033fad3429.svg";